import { SliderInput } from '@meitu/saas-ui';
import { IImageEffectShadow } from '@meitu/saas-editor-core/es/version-types';
import LabelAction from '@/components/label-action';
import { useLocaleStore } from '@/i18n';

const WaterSurfaceShadowItem: React.FC<{
    shadow: IImageEffectShadow;
    updateData: (data: { key: string; value: any }[], pushHistory?: boolean, stopUpdate?: boolean) => void;
}> = ({ shadow, updateData }) => {
    const { $t } = useLocaleStore();
    const blurChange = (blur: number, isEnd = false) => {
        updateData([{ key: 'blur', value: blur }], isEnd, isEnd);
    };

    const opacityChange = (opacity: number, isEnd = false) => {
        updateData([{ key: 'opacity', value: opacity }], isEnd, isEnd);
    };

    const waveChange = (wave: number, isEnd = false) => {
        updateData([{ key: 'wave', value: wave }], isEnd, isEnd);
    };

    const waveNumChange = (waveNum: number, isEnd = false) => {
        updateData([{ key: 'waveNum', value: waveNum }], isEnd, isEnd);
    };

    const waveDistanceChange = (waveDistance: number, isEnd = false) => {
        updateData([{ key: 'y', value: waveDistance }], isEnd, isEnd);
    };

    return (
        <>
            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.blur)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.blur ? shadow.blur * 100 : 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            blurChange(val / 100);
                        }}
                        onAfterChange={(val: number) => {
                            blurChange(val / 100, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.wave)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.wave || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            waveChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            waveChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.waveNum)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={shadow?.waveNum || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            waveNumChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            waveNumChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.dis)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={-100}
                        max={100}
                        value={shadow?.y || 0}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            waveDistanceChange(val);
                        }}
                        onAfterChange={(val: number) => {
                            waveDistanceChange(val, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>

            <LabelAction title={$t((v) => v.imageEffectPanel.imageShadowItem.opacity)} align>
                <div
                    style={{
                        width: '100%',
                    }}
                >
                    <SliderInput
                        min={0}
                        max={100}
                        value={(shadow?.opacity || 1) * 100}
                        precision={1}
                        showStepBtn
                        type="horizontal"
                        onChange={(val: number) => {
                            opacityChange(val / 100);
                        }}
                        onAfterChange={(val: number) => {
                            opacityChange(val / 100, true);
                        }}
                        onClick={() => {}}
                    />
                </div>
            </LabelAction>
        </>
    );
};

export default WaterSurfaceShadowItem;
